// extracted by mini-css-extract-plugin
module.exports =  {"overrideGap":"K6P2pNM7RPJpV7ehcpoP"};